const getEventData = (payload: { event: IModelEvent; videoType?: string; navigationPage: string }) => {
  const { event } = payload;

  return {
    client_type: "Web",
    event_id: event.eventId || "",
    event_name: event.title || "",
    event_status: event.eventStatus || "",
    id: event.id || "",
    navigation_page: payload.navigationPage || "",
    sport_type: event.sportType || "",
    video_type: payload?.videoType || "",
  };
};

export default {
  DownloadVideoStarted: {
    event: "Download Video Started",
    getData: getEventData,
  },
};
